module.exports = __webpack_public_path__ + "img/f-13.jpg";